// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3HfhG","footer":"Form_footer__12DLE"};